import { IFilesApiObject } from '../../@types/FilesAPIModels';

class FilesAPI2DModel {
  id: number;

  ownerId: number;

  name: string;

  filePath: string;

  fileName: string;

  fileFormat: string;

  fileSize: number;

  depth: number;

  length: number;

  previewImagePath: string;

  object: IFilesApiObject;

  rotation2D: number;

  constructor(
    id: number,
    ownerId: number,
    name: string,
    filePath: string,
    fileName: string,
    fileFormat: string,
    fileSize: number,
    depth: number,
    length: number,
    previewImagePath: string,
    object: IFilesApiObject,
    rotation2D: number,
  ) {
    this.id = id;
    this.ownerId = ownerId;
    this.name = name;
    this.filePath = filePath;
    this.fileName = fileName;
    this.fileFormat = fileFormat;
    this.fileSize = fileSize;
    this.depth = depth;
    this.length = length;
    this.previewImagePath = previewImagePath;
    this.object = object;
    this.rotation2D = rotation2D;
  }
}

export default FilesAPI2DModel;
